/* ==========================================================================
   STICK'IT — SKIN : « TON CUSTOM » → PANIER (additif, chargé après stickit.js)
   Le formulaire ne prend plus de coordonnées : une fois taille + couleur choisies,
   « Ajouter au panier » crée un produit final (aperçu du visuel ou du texte dans
   la couleur choisie) et l'ajoute au panier, comme l'outil casque.
   S'il manque la taille ou la couleur, on laisse la validation d'origine
   (stickit.js initForms) afficher ses messages.
   ========================================================================== */
(function () {
  'use strict';
  var doc = document;
  var form = doc.querySelector('form[data-demo]');
  var tierIn = doc.getElementById('tier-input');
  if (!form || !tierIn || !window.StickIt || !window.StickIt.cart) return;

  var COLORS = {"Blanc": "#FFFFFF", "Noir": "#0C0C0C", "Rouge": "#FF1717", "Jaune": "#FFC800", "Orange": "#FF9900", "Violet": "#8B4DFF", "Rose": "#FF59C7", "Vert": "#2ED573", "Bleu clair": "#4FC8F5", "Bleu foncé": "#1F3A8C", "Rose fuchsia": "#E6007E", "Bordeaux": "#6E1027", "Gris": "#8E8E93", "Gris Nardo": "#7C8084", "Rouge sang": "#8A0A0A", "Beige": "#D8C3A0", "Brun": "#6B4226", "Noir mat": "#1C1C1E", "Réfléchissant": "#D7D7DC", "Gris métallisé": "#9A9AA0", "Gris anthracite": "#3B3E43", "Holographique": "holo", "Doré": "#E3C466"};
  var RAMP = { 'Réfléchissant': ['#77777f', '#f5f5f8', '#a7a7af', '#ffffff', '#8b8b93'], 'Doré': ['#7d5d17', '#f3dc93', '#c49b3f', '#fff0c0', '#9a7629'],
    'Gris métallisé': ['#55555c', '#cfcfd5', '#85858d', '#e4e4e8', '#66666e'], 'Gris anthracite': ['#222428', '#6b6f76', '#3a3d42', '#878b92', '#2a2c30'] };
  var file = null;
  var drop = form.querySelector('.drop'), fileIn = doc.getElementById('file-input');
  var OK = ['image/jpeg', 'image/png', 'image/webp'];
  function keep(f) { file = f && OK.indexOf(f.type) > -1 && f.size <= 12 * 1024 * 1024 ? f : file; }
  if (fileIn) fileIn.addEventListener('change', function () { keep(fileIn.files[0]); });
  if (drop) {
    drop.addEventListener('drop', function (e) { if (e.dataTransfer && e.dataTransfer.files.length) keep(e.dataTransfer.files[0]); });
    drop.addEventListener('click', function (e) { if (e.target.classList.contains('clear')) file = null; }, true);
  }

  function val(id) { var el = doc.getElementById(id); return el ? String(el.value || '').trim() : ''; }
  function light(hex) {
    if (!/^#/.test(hex)) return true;
    var n = parseInt(hex.slice(1), 16); return (0.2126 * (n >> 16) + 0.7152 * (n >> 8 & 255) + 0.0722 * (n & 255)) / 255 > 0.55;
  }

  /* Visuel du produit final : 480 × 480, fond contrasté selon la couleur */
  function render(cb) {
    var S = 480, c = doc.createElement('canvas'); c.width = c.height = S;
    var x = c.getContext('2d'), col = COLORS[val('color-input')] || '#F5F3EF';
    var bg = light(col) ? '#121214' : '#E9E6E0';
    x.fillStyle = bg; x.fillRect(0, 0, S, S);
    var ink = function (w, h) {
      var stops = col === 'holo' ? ['#8FD9FF', '#C9A8FF', '#FFB3D9', '#FFE49A', '#9BFFD0'] : RAMP[val('color-input')];
      if (stops) {
        var g = x.createLinearGradient(0, 0, w, h);
        stops.forEach(function (s, i) { g.addColorStop(i / (stops.length - 1), s); });
        return g;
      }
      return col;
    };
    var text = file ? '' : 'Custom';
    function drawText(y, maxH) {
      if (!text) return;
      var size = maxH;
      x.font = '900 ' + size + 'px Archivo, Inter, sans-serif';
      while (x.measureText(text).width > S * 0.84 && size > 14) { size -= 2; x.font = '900 ' + size + 'px Archivo, Inter, sans-serif'; }
      x.fillStyle = ink(S, S); x.textAlign = 'center'; x.textBaseline = 'middle';
      x.fillText(text, S / 2, y);
    }
    if (!file) { drawText(S / 2, 110); return cb(c.toDataURL('image/jpeg', 0.85)); }
    var url = URL.createObjectURL(file), img = new Image();
    img.onload = function () {
      var box = text ? S * 0.66 : S * 0.84, k = Math.min(box / img.width, box / img.height);
      var w = img.width * k, h = img.height * k;
      x.drawImage(img, (S - w) / 2, (text ? S * 0.42 : S / 2) - h / 2, w, h);
      URL.revokeObjectURL(url);
      drawText(S * 0.86, 54);
      cb(c.toDataURL('image/jpeg', 0.85));
    };
    img.onerror = function () { URL.revokeObjectURL(url); drawText(S / 2, 110); cb(c.toDataURL('image/jpeg', 0.85)); };
    img.src = url;
  }

  var lockNote = form.querySelector('[data-lock-note]');
  var lockables = Array.prototype.slice.call(form.querySelectorAll('input:not([type=file]):not(#tier-input),select,textarea,.drop'));
  function lock() {
    var on = !doc.querySelector('.tier.on');
    form.classList.toggle('sk-locked', on);
    if (lockNote) lockNote.hidden = !on;
    lockables.forEach(function (el) { if (el.classList.contains('drop')) el.setAttribute('aria-disabled', String(on)); else el.disabled = on; });
  }
  Array.prototype.forEach.call(doc.querySelectorAll('.tier'), function (t) { t.addEventListener('click', function () { setTimeout(lock, 0); }); t.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') setTimeout(lock, 0); }); });
  lock();

  // phase de capture : on passe avant la validation de démonstration de stickit.js
  form.addEventListener('submit', function (ev) {
    var tier = form.ownerDocument.querySelector('.tier.on');
    var color = val('color-input');
    // toutes les étapes sont obligatoires, sauf le fichier : sinon stickit.js affiche les erreurs
    if (!tierIn.value || !tier || !color || !val('notes-input')) return;
    ev.preventDefault(); ev.stopImmediatePropagation();
    var alertBox = form.querySelector('.form-alert'); if (alertBox) alertBox.classList.remove('on');
    var colOpt = doc.getElementById('color-input').selectedOptions[0];
    var special = colOpt && colOpt.hasAttribute('data-special') ? parseFloat(tier.getAttribute('data-special')) || 0 : 0;
    var price = (parseFloat(tier.getAttribute('data-price')) || 0) + special;
    var notes = val('notes-input');
    var parts = ['Taille : ' + tier.getAttribute('data-label'), 'Hauteur : ' + tierIn.value, 'Couleur : ' + color + (special ? ' (spéciale +' + special.toFixed(2) + ' CHF)' : ''),
      'Fichier : ' + (file ? file.name : 'aucun'), 'Précisions : ' + notes];
    var cid = 'custom-' + Date.now(); if (file && window.SKFiles) window.SKFiles.put(cid, file);
    render(function (design) {
      window.StickIt.cart.add({
        id: cid,
        name: 'Sticker personnalisé',
        variant: parts.join(' · '),
        price: price,
        qty: 1,
        img: design,
        design: design
      });
    });
  }, true);
})();
